import React, { useEffect, useState } from 'react';
import appointmentService from '../../services/appointmentService';
import { formatDateLabel } from '../../utils/appointmentLogic';

/**
 * Stays on the page while any open appointment no longer fits its doctor's schedule or leave. It is computed by the server each time, so it
 * disappears by itself once every one of them has been rescheduled. It blocks nothing: confirming and arriving still work.
 */
export const DoctorConflictsBanner = ({ centreId, refreshKey, onOpen }) => {
  const [conflicts, setConflicts] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await appointmentService.doctorConflicts(centreId);
        if (!cancelled) setConflicts(res?.success ? res.data || [] : []);
      } catch (err) {
        if (!cancelled) setConflicts([]);       // the banner is a reminder; a failed lookup must not break the page
      }
    })();
    return () => { cancelled = true; };
  }, [centreId, refreshKey]);

  if (conflicts.length === 0) return null;
  return (
    <div className="apt-state apt-state-warn" role="status">
      <p>
        <strong>{conflicts.length} appointment{conflicts.length === 1 ? '' : 's'} need{conflicts.length === 1 ? 's' : ''} rescheduling</strong>
        {' '}because a doctor's schedule or leave changed.{' '}
        <button type="button" className="apt-link" aria-expanded={open} onClick={() => setOpen((v) => !v)}>{open ? 'Hide' : 'Show'}</button>
      </p>
      {open && (
        <ul className="apt-plain-list">
          {conflicts.map((c) => (
            <li key={c.appointmentId}>
              <span><strong>{c.appointmentNo}</strong> · {c.pName} · {c.doctorName} · {formatDateLabel(c.appointmentDate.slice(0, 10))} {c.slotStart} <em className="apt-muted">({c.reason})</em></span>
              <button type="button" className="apt-btn apt-btn-sm" onClick={() => onOpen?.(c.appointmentId)}>Open</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DoctorConflictsBanner;
